// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.HeaderBottom_show-on-mobile__uRM4p {
  display: none;
}

.HeaderBottom_hide-on-mobile__izlF4 {
  display: flex;
}

@media (max-width: 1024px) {
  .HeaderBottom_hide-on-mobile__izlF4 {
    display: none !important;
  }
}
@media (max-width: 1024px) {
  .HeaderBottom_show-on-mobile__uRM4p {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Page/HeaderBottom.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;ADkDE;ECrDE;IACI,wBAAA;EAON;AACF;AD4CE;EChDE;IACI,aAAA;EAON;AACF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.show-on-mobile {\n  display: none;\n}\n\n.hide-on-mobile {\n  display: flex;\n}\n\n@media (max-width: 1024px) {\n  .hide-on-mobile {\n    display: none !important;\n  }\n}\n@media (max-width: 1024px) {\n  .show-on-mobile {\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"show-on-mobile": `HeaderBottom_show-on-mobile__uRM4p`,
	"hide-on-mobile": `HeaderBottom_hide-on-mobile__izlF4`
};
export default ___CSS_LOADER_EXPORT___;
